import type { AjaxResponse } from 'rxjs';
import { post } from '@helpcenter/ajax';
import { Observable } from '@helpcenter/epics-rxjs';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { contextPath } from '@atlassian/help-center-common-util/history';

export const resetPassword = (params: {
    emailAddress: string;
    password: string;
    token: string;
    context?: string;
    resetPasswordJwt?: string;
}) => {
    const { emailAddress, password, resetPasswordJwt, token, context = contextPath } = params;
    const isResetPasswordJwtEnabled = FeatureGates.checkGate('jsm-banana-4371-reset-pwd-new-resetpasswordjwt');

    const uri =
        isResetPasswordJwtEnabled && resetPasswordJwt
            ? `${context}/rest/servicedesk/1/customer/pages/user/resetpassword?jwt=${resetPasswordJwt}`
            : `${context}/rest/servicedesk/1/customer/pages/user/resetpassword`;

    const body = {
        emailAddress,
        password,
        // eslint-disable-next-line no-nested-ternary
        ...(isResetPasswordJwtEnabled ? (token.length > 0 ? { token } : {}) : { token }),
    };

    const headers = {
        'Content-Type': 'application/json',
    };

    return (
        post(uri, body, headers)
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .map(({ response }: AjaxResponse) => response)
            .catch((e) => Observable.throw(e))
    );
};
